<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
import leylo from "leylo";
export default {
  mounted() {
    console.log("Hello world");
  }
};
</script>

<style>
html {
  min-width: 400px;
  min-height: 400px;
  background-color: #fff;
  margin: 0px;
  padding: 0px;
}

.minheight {
  height: 400px;
  width: 400px;
  z-index: 0;
}
</style>
